import styled from "styled-components";
import {device} from "../../themes/Breakpoints";
import { createGlobalStyle } from "styled-components";


export const ScoutingWrap = styled.section`
  max-width:1440px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:80px 20px 120px;
  .blockTitle{
    max-width: 1440px;
    width: 100%;
    border:1px solid #8C8C8C;
    border-left: 6px solid #F15A24;
    background: transparent;
    color: #022142;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 64px;
    margin-bottom: 24px;
    text-align: left;
    padding: 4px 12px;
  }
  @media only screen and (max-width: 1249px) {
    padding: 40px 20px 40px;
  }
  @media only screen and (max-width: 767px) {
    padding: 40px 10px 40px;
  }
  @media only screen and (max-width: 600px) {
    .blockTitle{
      font-size: 24px;
      line-height: 32px;
    }
`
export const ScoutingBlock= styled.div`
  display: flex;
  max-width: 1440px;
  width: 100%;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 44px;
  @media only screen and (max-width: 768px) {
    margin-top: 8px
  }
`;

export const SingleOne = styled.div`
  width: 48%;
  display: flex;
  gap: 24px;
  .upDiv{
    display: flex;
    margin-bottom: 10px;
    align-items: center;
  }
  .logoIcon{
    width: 26px;
    height: 31px;
  }
  .nfl-analysis{
    padding: 0 8px;
    background: #022142;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 30px;
    display: flex;
    align-items: center;
    margin: 0;
    line-height: normal;
  }
  .mainImage{
    width: 50%;
  }
  .rightPart{
    width: 48%;
    display: flex;
    flex-direction: column;
  }
  .title{
    margin-bottom: 5px;
    color: #555;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
  }
  .text{
    color: #555;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 26px;
  }
  .below{
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .icon{
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
  span{
    display: flex;
    align-items: center;
    color: #878787;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  @media only screen and (min-width: 1101px)and (max-width: 1300px) {
    gap: 22px;
    .title{
      line-height: 24px;
    }
    .text{
      margin-bottom: 8px;
    }
  }
  @media only screen and (min-width: 1024px)and (max-width: 1100px) {
    width: 100%;
  }
  @media ${device.tabletL} {
    width: 100%;
  }
  @media ${device.tablet}{
    width: 100%;
  }
  @media only screen and (min-width: 600px)and (max-width: 767px) {
    width: 100%;
  }
  @media only screen and (max-width: 599px) {
    width: 100%;
    flex-direction: column;
    gap: 12px;
    .mainImage{
      width: 100%;
    }
    .rightPart {
      width: 100%;
    }
  }
  @media only screen and (max-width:767px) {
    .title{
      font-size: 18px;
      line-height: 24px;
    }
    .text{
      margin-bottom: 8px;
    }
  }
`;

export const ReportCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 28px 32px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 32px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 12px;
    padding: 16px 8px;
  }
`;
export const ReportCol = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
export const Label = styled.div`
  font-size: 13px;
  color: #888;
  font-weight: 500;
  margin-bottom: 2px;
`;
export const Value = styled.div`
  font-size: 22px;
  color: #022142;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 2px;
  &.position, &.school { color: #022142; font-size: 18px; font-weight: 700; }
`;
export const ReportText = styled.div`
  font-size: 15px;
  color: #555;
  font-weight: 400;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 420px;
`;

export const ScoutingReportGlobalStyles = createGlobalStyle`
  .player-name {
    font-size: 2.2rem;
    font-weight: 700;
    color: #223355;
    margin-bottom: 4px;
  }
  .player-meta {
    font-size: 1.1rem;
    color: #888;
    font-weight: 600;
    margin-bottom: 12px;
    display: flex;
    gap: 16px;
  }
  .player-physical {
    font-size: 1rem;
    color: #444;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .verified {
    color: #4caf50;
    font-size: 0.95em;
    margin-left: 4px;
    font-weight: 500;
  }
  .stats-awards {
    margin-top: 18px;
  }
  .stats-label {
    font-size: 1.2rem;
    font-weight: 700;
    color: #888;
    margin-bottom: 8px;
    display: block;
  }
  .stats-list {
    font-size: 1rem;
    color: #444;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .team-logo {
    width: 120px;
    height: auto;
    margin: 16px 0 18px 0;
    display: block;
  }
`;